import { createSelector } from 'reselect'
import whiteboardModes from 'helpers/enums/whiteboardModes'
import sizeSelector from 'redux/selectors/ui/sizeSelector'

const getWhiteboardData = state => state.whiteboardSession

const getStudentSlideData = createSelector(
	[ sizeSelector, getWhiteboardData ],
	(size, whiteboard) => {

		const cached = whiteboard.actions.teacher

		const {mode} = whiteboard

		return {
			size,
			cached,
			isEnabled: whiteboard.mode !== whiteboardModes.NONE,
			hasBackground: whiteboard.mode === whiteboardModes.WHITEBOARD,
			mode,
		}
	}
)

export default getStudentSlideData
